import React from 'react';
import { IconProps } from './IconTypes';

const VegaLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M50,4 C53,32 68,47 96,50 C68,53 53,68 50,96 C47,68 32,53 4,50 C32,47 47,32 50,4 Z" />
      <path d="M14,14 C26,28 30,30 38,38 L34,42 C26,34 22,30 14,14 Z" />
      <path d="M86,14 C74,28 70,30 62,38 L66,42 C74,34 78,30 86,14 Z" />
      <path d="M14,86 C26,72 30,70 38,62 L34,58 C26,66 22,70 14,86 Z" />
      <path d="M86,86 C74,72 70,70 62,62 L66,58 C74,66 78,70 86,86 Z" />
    </svg>
  );
};

export default VegaLogo;
